import { Button, type ButtonProps } from "~/components/ui/button";
import { Link } from "react-router";
import { useSession } from "~/lib/auth/auth.client";

export function GetStartedButton({
  label = "Get Started",
  dashboardLabel = "Dashboard",
  ...props
}: ButtonProps & { label?: string; dashboardLabel?: string }) {
  const { data: session } = useSession?.() || {};

  return (
    <Button asChild {...props}>
      <Link to={session ? "/dashboard" : "/sign-in"}>
        {session ? dashboardLabel : label}
      </Link>
    </Button>
  );
}
